import React from 'react';

import { faArrowDownToLine } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components';

import type { ReferralRecord } from '../referralPageTypes';

import { useReferralPdfGenerator } from './ReferralPdfDownload/ReferralPdfGenerator';

interface PdfButtonProps {
  referral: ReferralRecord;
}

export const PdfButton: React.FC<PdfButtonProps> = ({ referral }) => {
  const { generatePdf, isGenerating, isLoading, hasData } =
    useReferralPdfGenerator({
      referralId: referral.id,
    });

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isGenerating || isLoading || !hasData) return;
    await generatePdf();
  };

  return (
    <Button
      variant="outline"
      size="sm"
      className="vai-flex vai-items-center vai-py-1.5 vai-text-blue-600 vai-border-blue-200 hover:vai-bg-blue-50 vai-h-7"
      onClick={handleClick}
      disabled={isGenerating || isLoading || !hasData}
    >
      <FontAwesomeIcon icon={faArrowDownToLine} />
      <span>{isGenerating ? 'Generating...' : 'PDF'}</span>
    </Button>
  );
};
